import { render, staticRenderFns } from "./CardTitleSelector.vue?vue&type=template&id=1138ffd4&scoped=true&lang=html&"
import script from "./CardTitleSelector.vue?vue&type=script&lang=js&"
export * from "./CardTitleSelector.vue?vue&type=script&lang=js&"
import style0 from "./CardTitleSelector.vue?vue&type=style&index=0&id=1138ffd4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138ffd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VList,VListItem,VListItemTitle,VTextField})
